<script context="module">
  export const options = {
    responsive: true,
    elements: {
      point: {
        radius: 2,
        hoverRadius: 6,
      },
      line: {
        borderWidth: 4,
      },
    },
    locale: "it-IT",
    scales: {
      xAxes: [
        {
          type: "time",
          time: {
            parser: "DD/MM/YYYY, HH:mm:ss",
            unit: "hour",
            unitStepSize: 6,
            displayFormats: {
              hour: "HH:mm",
            },
          },
        },
      ],
      
    },
   
      legend: {
          labels :{
            fontSize: 16,
            fontWeight: 'bold'
          }
      }
    
  };
</script>
